import React, { useState, useEffect, useRef, Fragment, useCallback, useMemo } from 'react';
import { DataGridPro, GridRowEditStopReasons, GridRowModes, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from '@mui/material/Modal';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { FaChevronDown } from 'react-icons/fa';
import DisplayPBSegment from '../../components/Modals/DisplayPBSegment';
import { FaSyncAlt } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import { ListsModal } from '../../contexts';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import _ from 'lodash';
import { update, changePlaybookStatus } from '../../common/api';


import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';

const toolbar = ( { selectedRows, handleMassModal, canExport } ) => {
    return(
        <GridToolbarContainer>
            <Container fluid className='p-0'>
                <Row className='p-0 align-items-center'>
                    <Col>
                        <Row className='text-start align-items-center'>
                            <Col xs='auto' className='pe-0'>
                                <GridFooter className='tf-fake-footer' />
                            </Col>
                            <Col xs='auto'>
                                { 
                                    selectedRows.length > 0 &&
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'activate' ) }>Activate</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'disable' ) }>Disable</Dropdown.Item>
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className='text-right'>
                        <GridToolbarQuickFilter />
                    </Col>
                    {
                        ( canExport ) ? (
                            <Col xs='auto' className='pe-3 text-right'>
                                <GridToolbarExport />
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
            </Container>
        </GridToolbarContainer>
    )
}

const Automations = ( { orgId, aid, uid, user, viewing, canExport, stack, playbooks, contacts, loans, leadopps, rates } ) => {
    const [ gridHeight, setGridHeight ] = useState( 1 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    const [ loading, setLoading ] = useState( true );
    const [ lLists, setLists ] = useState( [] );
    const [ selectedRows, setSelectedRows ] = useState( [] );
    const [ rowModesModel, setRowModesModel ] = useState( {} );
    const [ hasUnsavedRows, setHasUnsavedRows ] = useState( false );
    const [ isSaving, setIsSaving ] = useState( false );
    const [ singleSaveId, setSingleSaveId ] = useState( '' );
    const [ todaysRates, setTodaysRates ] = useState( {} );
    const [ ratesSet, setRatesSet ] = useState( false );

    const handleSave = async ( objType, oid, draftValues ) => {
        const pb = playbooks[oid];
        console.log( 'Saving: ' + pb.aid + ' - ' + objType + ' - ' + oid, draftValues );
        const updated = await update( orgId, pb.aid, uid, objType, oid, draftValues );
        if ( updated.length ) {
            toast.success( `Your changes have been saved`, { theme: 'dark' } );
        }
    }

    const getSegment = useCallback( ( pid ) => {
        const pb = playbooks[pid];
        let list = [];
        if ( pb && pb.rule && pb.rule.logic ) {
            // console.log( 'eval ' + pb.name + ': ' + pb.rule.logic );
            const today = new Date();

            try {
                console.log( 'running eval on ', pb );
                console.log( 'getSegment rates: ', todaysRates );
                eval( pb.rule.logic );
            } catch ( e ) {
                console.log( 'Eval Error: ', e );
            }

            if ( list.length && pb.rule.key ) {
                // console.log( pb.aid + ' - ' + pb.name + ': Before last step check: ' + list.length );
                const lastStep = pb.steps.slice( -1 )[0];
                if ( lastStep.interval ) {
                    list = list.filter( l => {
                        if ( l[pb.rule.key] ) {
                            const d = new Date( l[pb.rule.key] );
                            const diff = ( today.getTime() - d.getTime() ) / ( 1000 * 60 * 60 * 24 );
                            if ( diff <= lastStep.interval ) {
                                return true;
                            } 
                        }
                        return false;
                    } );
                }
                console.log( 'pb: ', pb );
                list.sort( ( a, b ) => {
                    if ( !a[pb.rule.key] ) {
                        return 1;
                    }
                    if ( !b[pb.rule.key] ) {
                        return -1;
                    }
                    const ad = new Date( a[pb.rule.key].match( 'T' ) ? a[pb.rule.key] : a[pb.rule.key] + 'T12:00:00' );
                    const bd = new Date( b[pb.rule.key].match( 'T' ) ? b[pb.rule.key] : b[pb.rule.key] + 'T12:00:00' );
                    return bd.getTime() - ad.getTime();
                } );
                // console.log( pb.aid + ' - ' + pb.name + ': After last step check: ' + list.length );
            }
            // console.log( 'list: ', list );
        }
        return list;
    }, [ playbooks, todaysRates ] );

    const calcSegment = useCallback( ( pid ) => {
        const list = getSegment( pid );
        return list.length;
    }, [ getSegment ] );

    const containerRef = useRef();
    const titleRef = useRef();
    const unsavedChangesRef = useRef( { unsavedRows: {}, rowsBeforeChange: {} } );

    const gridRef = useGridApiRef();

    const handleRowEditStop = ( params, event ) => {
        if ( params.reason === GridRowEditStopReasons.rowFocusOut ) {
          event.defaultMuiPrevented = true;
        }
    };
    
    const handleEditClick = useCallback( ( id ) => () => {
        setRowModesModel( { 
            ...rowModesModel, 
            [id]: { mode: GridRowModes.Edit } 
        } );
    }, [ rowModesModel ] );
    
    const handleSingleSaveClick = useCallback( ( id ) => () => {
        setSingleSaveId( id );
        setIsSaving( true );
        setRowModesModel( { 
            ...rowModesModel, 
            [id]: { mode: GridRowModes.View } 
        } );
        
        gridRef.current.stopRowEditMode( { id: id } );
    }, [ rowModesModel, gridRef ] );
    
    const handleCancelClick = useCallback( ( id ) => () => {
        gridRef.current.updateRows( [
            unsavedChangesRef.current.rowsBeforeChange[id],
        ] );
        delete unsavedChangesRef.current.rowsBeforeChange[id];
        delete unsavedChangesRef.current.unsavedRows[id];
        setHasUnsavedRows(
            Object.keys( unsavedChangesRef.current.unsavedRows ).length > 0,
        );

        setRowModesModel( {
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        } );
    }, [ rowModesModel, gridRef ] );
    
    const findDiff = ( newObj, origObj ) => {
        let obj = {};

        function processKeyValue( key, value, otherObject ) {
            if ( !_.has( otherObject, key ) || !_.isEqual( value, otherObject[key] ) ) {
                obj[key] = value;
            }
        }

        _.forEach( newObj, ( value, key ) => processKeyValue( key, value, origObj ) );

        return obj;
    }

    const processRowUpdate = async ( newRow, origRow ) => {
        const rowId = newRow.id;
        unsavedChangesRef.current.unsavedRows[rowId] = newRow;
        if ( !unsavedChangesRef.current.rowsBeforeChange[rowId] ) {
            unsavedChangesRef.current.rowsBeforeChange[rowId] = origRow;
        }

        if ( isSaving && rowId === singleSaveId ) {
            let obj = findDiff( newRow, unsavedChangesRef.current.rowsBeforeChange[rowId] );
            
            await handleSave( 'playbook', rowId, obj );

            delete unsavedChangesRef.current.rowsBeforeChange[rowId];
            delete unsavedChangesRef.current.unsavedRows[rowId];
            
            setIsSaving( false );
            setSingleSaveId( '' );
        }
        
        setHasUnsavedRows(
            Object.keys( unsavedChangesRef.current.unsavedRows ).length > 0,
        );

        return newRow;
    };
    
    const handleRowModesModelChange = ( newRowModesModel ) => {
        setRowModesModel( newRowModesModel );
    };

    const handleSingleModal = useCallback( ( t, pid ) => {
        let shouldOpen = true;
        
        switch ( t ) {
            case 'display-segment':
                let list = getSegment( pid );
                setModal( <DisplayPBSegment pid={pid} segment={list} close={closeModal} /> );
                break;

            default:
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }, [ getSegment ] );

    const handleMassModal = async ( t ) => {
        let shouldOpen = true;

        const list = [];
        selectedRows.forEach( pid => {
            console.log( pid );
            const pb = playbooks[pid];
            list.push( { aid: pb.aid, pid: pb.pid } );
        } );

        let update = [];
        switch ( t ) {
            case 'activate':
                shouldOpen = false;
                console.log( 'calling changePlaybookStatus with: ', list );
                update = await changePlaybookStatus( uid, list, true );
                console.log( 'update: ', update );
                break;

            case 'disable':
                shouldOpen = false;
                update = await changePlaybookStatus( uid, list, false );
                break;
    
            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        } else {
            if ( update && update.length ) {
                toast.success( `Your changes have been saved`, { theme: 'dark' } );
            }
        }
    }

    let cols = useMemo( () => [
        { 
            field: 'name', 
            headerName: 'Automation', 
            width: 350, 
            renderCell: ( params ) => <Link to={`/playbook/${params.row.pid}`}>{params.value}</Link>, 
        },
        { 
            field: 'mode', 
            headerName: 'Mode', 
            width: 150
        },
        { 
            field: 'rule.description', 
            headerName: 'Audience Description', 
            flex: 1,
            valueGetter: ( { row } ) => {
                let rule;
                if ( row.rule && row.rule.description ) {
                    rule = row.rule.description;
                }
                return rule;
            },
            valueSetter: ( params ) => {
                return { 
                    ...params.row,
                    rule: {
                        ...params.row.rule,
                        description: params.value
                    }
                }
            },
            // editable: true,
            obj: 'playbook'
        },
        { 
            field: 'steps', 
            headerName: 'Actions', 
            type: 'number',
            renderCell: ( params ) => ( params.row.steps && params.row.steps.length ) ? params.row.steps.length : 0,
            // width: 100 
        },
        { 
            field: 'members',
            headerName: 'Members',
            type: 'number',
            // valueGetter: ( params ) => calcSegment( params ),
            renderCell: ( params ) => <Button variant='link' size='sm' onClick={ () => handleSingleModal( 'display-segment', params.row.pid ) }>{params.value}</Button>
        },
        { field: 'active', headerName: 'Active', type: 'boolean', width: 100, editable: true },
    ], [ handleSingleModal ] );

    useEffect( () => {
        document.title = 'Third Floor - Automations';
    }, [] );

    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        setRatesSet( true );
    }, [ todaysRates ] );

    useEffect( () => {
        if ( !ratesSet ) {
            rates.sort( ( a, b ) => new Date( b.date ) - new Date( a.date ) );
            const tr = {};
            if ( rates.length ) {
                const d = rates[0].date;
                const r = rates.filter( f => f.date === d );

                r.forEach( f => {
                    tr[f.program] = {
                        rate: f.rate,
                        change: f.change
                    };
                } );
                setTodaysRates( tr );
            }
        } else {
            let list = [];
            Object.keys( playbooks ).forEach( pid => {
                const p = playbooks[pid];
                if ( viewing.includes( p.aid ) && p.version !== 2 ) {
                    const scheduled = p.steps?.some( f => f.interval > 0 || f.repeats );
                    const realtime = p.steps?.some( f => f.interval === 0 );

                    list.push( {
                        ...p,
                        members: calcSegment( pid ),
                        mode: ( scheduled ) ? ( ( realtime ) ? 'Hybrid' : 'Scheduled' ) : ( realtime ? 'Realtime' : 'Unknown' )
                    } );
                }
            } );
            list.sort( ( a, b ) => {
                const ua = ( a.name ) ? a.name.toUpperCase() : null;
                const ub = ( b.name ) ? b.name.toUpperCase() : null;
                if ( ua < ub ) {
                    return -1;
                }
                if ( ua > ub ) {
                    return 1;
                }
                return 0;
            } );
            setLists( list );
            setLoading( false );
        }
    }, [ aid, uid, playbooks, viewing, rates, calcSegment, ratesSet, todaysRates ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <FaSyncAlt />
                                        <span className='ps-2 fw-bold fs-6'>Automations</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ListsModal.Provider value={ { openModal, closeModal, setModal } }>
                                        <DataGridPro
                                            apiRef={gridRef}
                                            loading={ loading }
                                            rows={lLists}
                                            columns={cols}
                                            density='compact'
                                            checkboxSelection
                                            disableSelectionOnClick
                                            slots={ { toolbar: toolbar } }
                                            slotProps={ { toolbar: {
                                                selectedRows: selectedRows, 
                                                handleMassModal: handleMassModal,
                                                canExport: canExport,
                                            } } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                            getRowId={ ( row ) => row.pid }
                                            editMode='row'
                                            rowModesModel={ rowModesModel }
                                            onRowModesModelChange={ handleRowModesModelChange }
                                            onRowEditStop={ handleRowEditStop }
                                            processRowUpdate={ processRowUpdate }
                                        />
                                    </ListsModal.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    playbooks: state.playbooks.byId,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    leadopps: state.leadopps.byId,
    rates: state.user.rates
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadLists
} );
  
export default connect( mapProps, mapDispatch )( Automations );